var $=jQuery;
jQuery(document).ready(function ($) {
  $(document).on('click','.js .menu-drawer__menu li > summary', function() {
       $('#menu-drawer').addClass('active');
  });
  $('.crosscell_pdp.has-lm a.button.button--primary').on('click', function() {
      // $(this).hide();
      $('.crosscell_pdp.has-lm').toggleClass('active');
      $('html, body').animate({
        scrollTop: $('.bundlel-sec-custom').offset().top - 150 
      }, 'slow');
  });
 function setEqualHeight() {
      var maxHeight = 0;
      $('.collection .card__heading').css('height', 'auto');
  
      $('.collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }

    $(document).ready(function() {
        setEqualHeight();
    });
    
    $(window).on('resize', function() {
        setEqualHeight();
    });
    $('.menu-drawer .menu-drawer__menu-item>.svg-wrapper').on('click', function() {
      $('#menu-drawer .menu-drawer__navigation-container').addClass('active');
    });
    $('.menu-drawer__close-button').on('click', function() {
      $('#menu-drawer .menu-drawer__navigation-container').removeClass('active');
    });
    
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
    });
  //slider mini cart
//   var swiper = new Swiper('.slider-upsell', {
//     slidesPerView: 1,
//     spaceBetween:0,
//     loop: true,
//     centeredSlides: true,
//     autoplay: {
//       delay: 50000,
//       disableOnInteraction: false,
//     }
//   });
    var swiperInstance;
  function initSwiper() {
    var testimonials = $('.testimonials-section').length;
    if (testimonials > 0) {
      if (swiperInstance && swiperInstance.destroy) {
          swiperInstance.destroy(true, true);
      }
  
      swiperInstance = new Swiper(".testimonials-section .swiper", {
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 4,
              slideShadows: false
          },
          loop: true,
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
          },
             pagination: {
                el: ".testimonials-section .swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                if (index < 3) {
                    return '<span class="' + className + '"></span>';
                }
                return ''; 
                }
            },
          keyboard: {
              enabled: true
          },
          
          mousewheel: false,
          breakpoints: {
                0: {
                    mousewheel: {
                        thresholdDelta: 70
                    },
                },
              1024: {
                  slidesPerView: 3
              }
          }
      });
    }
  }
  
  window.addEventListener("resize", function () {
      initSwiper();
  });
  
  // Initial call to setup swiper
  initSwiper();
  $('.footer-block.has_dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('.read-more-mobile').click(function (e) { 
      e.preventDefault();
      $(this).hide();
      $('.read_more_mobile_st .rich-text__text').addClass('read-more-text');
  });
  //Start Slider mobile
  function initFlickityMobile() {
    if ($(window).width() < 950) {
      $(".has_slider .multicolumn-list").each(function () {
        if (!$(this).data('flickity')) {      
          $(this).flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: false,
            autoPlay: 10000,
            groupCells: false,
            cellAlign: 'center'
          });
        }
      });
      $(".nt_handgefarbt_unsere .swiper-wrapper").each(function () {
        if (!$(this).data('flickity')) {      
          $(this).flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: true,
            autoPlay: 10000,
            groupCells: false,
            cellAlign: 'center'
          });
        }
      });
    }
  }
  $(document).ready(initFlickityMobile);

  $(window).on('resize', function () {
    initFlickityMobile();
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');

    if (!loadMoreButton) return;

    loadMoreButton.addEventListener('click', function(e) {
        e.preventDefault();

        const nextUrl = loadMoreButton.getAttribute('href');
        loadMoreButton.textContent = "Laden...";
        loadMoreButton.setAttribute('disabled', 'true');

        fetch(nextUrl)
            .then(response => response.text())
            .then(data => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data;

                const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                productGrid.innerHTML += newProducts;

                const newButton = tempDiv.querySelector('[data-pagination-btn]');

                if (newButton) {
                    loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                    loadMoreButton.textContent = "Weitere Produkte";
                    loadMoreButton.removeAttribute('disabled');
                } else {
                    loadMoreButton.remove(); // remove 
                }
            })
            .catch(error => {
                loadMoreButton.textContent = "Weitere Produkte";
                loadMoreButton.removeAttribute('disabled');
            });
    });
});

